import type { CarriersFilterState } from '@web-platform/shared-universal-types/src/redux/state/flightSearchResults/features/filters/carriers';

export const INITIAL_STATE: CarriersFilterState = {};
